import {Dispatch} from "redux";
import {createAction} from 'Shared/utilities/actionCreator';

export enum TokenRefreshActionTypes {
  INITIATE_TOKEN_REFRESH = 'token/INTIATE_TOKEN_REFRESH',
  REFRESH_TOKEN = 'token/REFRESH_TOKEN',
  TOGGLE_REFRESH_SPINNER = 'token/TOGGLE_REFRESH_SPINNER',
  LOGOUT = 'token/LOGOUT',
}

export enum TokenRefreshSessionKeys {
  MASKED_IDENTIFIER = 'maskedIdentifier',
  RE_ROUTE_OPTIONS = 'reRouteOptions',
  SAVED_ENCRYPTED_ID = 'savedEncryptedId',
  NEWYORK_STATUS = 'newYorkStatus',
  TOKEN_REFRESH_FLAG = 'shouldRefreshToken',
}

export enum TokenRefreshLocalKey {
  IN_EMULATION = 'inEmulation',
}

export type TokenSet = {
  access_token: string;
  expires_in: number;
  id_token: string;
  scope: string;
  token_type: string;
};

export const initiateTokenRefresh = (maskedIdentifier?: string) => {
  return createAction(TokenRefreshActionTypes.INITIATE_TOKEN_REFRESH, {maskedIdentifier});
};

export const tokenRefresh = (state: string, dispatch?: Dispatch) => {
  return createAction(TokenRefreshActionTypes.REFRESH_TOKEN, {state, dispatch});
};

export const toggleRefreshSpinner = (isOpen: boolean, spinnerLabel?: string, expiresAt?: number) => {
  return createAction(TokenRefreshActionTypes.TOGGLE_REFRESH_SPINNER, {isOpen, spinnerLabel, expiresAt});
};

export const logoutISAM = () => {
  return createAction(TokenRefreshActionTypes.LOGOUT);
};

type RefreshSpinnerState = {
  isOpen: boolean;
  spinnerLabel?: string;
  expiresAt?: number
};

export const DEFAULT_STATE: RefreshSpinnerState = {
  isOpen: false,
  spinnerLabel: undefined,
  expiresAt: 0,
};

type TokenAction = ReturnType<typeof toggleRefreshSpinner>;

export default (state: RefreshSpinnerState = DEFAULT_STATE, action: TokenAction): RefreshSpinnerState => {
  switch (action.type) {
    case TokenRefreshActionTypes.TOGGLE_REFRESH_SPINNER:
      return {
        ...state,
        isOpen: action.payload.isOpen,
        spinnerLabel: action.payload.spinnerLabel,
        expiresAt: action.payload.expiresAt
      };
    default:
      return state;
  }
};
